import {Table} from "antd";
import styled from 'styled-components';

export const StyledTable = styled(Table)`
  .ant-table-small {
      border: 0;
  }
`
